// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__24mwM","author":"Table_author__38kgc","authorImage":"Table_authorImage__1Jr2e","unreadRow":"Table_unreadRow__T4mec"};